module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img64.522a231e.jpg";